export const ACCESS_ERRORS = {
	UNAUTHORIZED: "unauthorized",
	COMMUNITY_ID_REQUIRED: "community_id_required",
	NOT_A_COMMUNITY_MEMBER: "not_a_community_member",
	INSUFFICIENT_PERMISSIONS: "insufficient_permissions",
	NOT_STAFF: "not_staff",
} as const;

export type AccessErrorCode = (typeof ACCESS_ERRORS)[keyof typeof ACCESS_ERRORS];
